import React from "react";
import "./style/footer.css"
import insta_icon from "../assets/footer/icons_footer/insta.svg"
import fb_icon from "../assets/footer/icons_footer/facebook.svg"
import twitter_ico from "../assets/footer/icons_footer/twitter.svg"
import linkedin_icon from "../assets/footer/icons_footer/linkedin.svg"
import ScrollToTop from 'react-scroll-up';
import top from "../assets/footer/up-arrow.svg"
import { NavLink } from "react-router-dom";
import ReactSVG from 'react-svg'

class Footer extends React.Component {

  render() {
    return (
      <div className="footerBack">
          <ScrollToTop showUnder={160} style={{zIndex:"4"}}>
            <div className="flex-top">
            <ReactSVG svgStyle={{ width: "48%", marginTop: "-114px" }} src={top} />
            </div>
            </ScrollToTop>
            <div className="flex-footer">
              <div style={{margin: "0 auto"}}>
                
                  <div><p className="textContactNous">Besoin d'en savoir plus ?</p></div>
               
                <NavLink to="/solutions" style={{textDecoration: "none"}}  exact={true}>
                  <div id="divSol"><p className="SolFooter">solutions</p></div>
                </NavLink>
                <div id="divlienfooter">
                  <div className="lienFooter">
                      <div><p className="textfooter" style={{textDecoration:"none",opacity:"0.5"}}>Mention légales</p></div>
                      <div id="leftdiv"><p className="textfooter">Notre plaquettes</p></div>
                      <div id="leftdiv"><p className="textfooter">Télécharger notre kit presse</p></div>
                  </div>
                </div>
              </div>


              <div style={{margin: "0 auto"}}>
                  <div>
                    <p className="textContactNous">Contactez-Nous</p>
                  </div>
                  <div id="divContact">
                  
                  <div>
                  <a
                      href="mailto:contact@chifco.com"
                      style={{
                       
                        textDecoration: "none"
                      }}
                    >
                    <p className="contactfooter">contact@chifco.com</p>
                    </a>
                  </div>
                    <div>
                    <a
                      href="tel:+216 73 82 09 30"
                      style={{
                       
                        textDecoration: "none"
                      }}
                    >
                      <p className="contactfooter">+216 73 82 09 30</p>
                      </a>
                    </div>
                  </div>
                  <div className="divImgFooter">
                    <div>
                      <a href="https://www.instagram.com/chifco_iot/" rel="noopener noreferrer" target="_blank">
                        <ReactSVG src={insta_icon} />
                      </a>
                    </div>
                    <div id="leftImg">
                      <a href="https://twitter.com/bechifco" rel="noopener noreferrer" target="_blank">
                        <ReactSVG src={twitter_ico} />
                      </a>
                    </div>  
                    <div id="leftImg">
                      <a href="https://www.facebook.com/chifco/" rel="noopener noreferrer" target="_blank"><ReactSVG src={fb_icon} /></a>
                    </div>
                    <div id="leftImg">
                      <a href="https://www.linkedin.com/company/chifco/?originalSubdomain=fr" rel="noopener noreferrer" target="_blank"><ReactSVG src={linkedin_icon} /></a>
                    </div>
                  </div>
              </div>
            </div>
      </div>
    );
  }
}
export default Footer;


// WEBPACK FOOTER //
// ./src/home/footer.js